import blackStandard from "./aircraft-black-standard.svg";
import brownStandard from "./aircraft-brown-standard.svg";
import darkblueStandard from "./aircraft-darkblue-standard.svg";
import darkgreenStandard from "./aircraft-darkgreen-standard.svg";
import darkredStandard from "./aircraft-darkred-standard.svg";
import grayStandard from "./aircraft-gray-standard.svg";
import lightblueStandard from "./aircraft-lightblue-standard.svg";
import lightgreenStandard from "./aircraft-lightgreen-standard.svg";
import lightredStandard from "./aircraft-lightred-standard.svg";
import magentaStandard from "./aircraft-magenta-standard.svg";
import orangeStandard from "./aircraft-orange-standard.svg";
import purpleStandard from "./aircraft-purple-standard.svg";
import salmonStandard from "./aircraft-salmon-standard.svg";
import violetStandard from "./aircraft-violet-standard.svg";
import whiteStandard from "./aircraft-white-standard.svg";
import yellowStandard from "./aircraft-yellow-standard.svg";

import VesselColour from "../../../Enums/VesselColour";

const iconImages = {};
iconImages[VesselColour.BLACK] = blackStandard;
iconImages[VesselColour.BROWN] = brownStandard;
iconImages[VesselColour.DARKBLUE] = darkblueStandard;
iconImages[VesselColour.DARKGREEN] = darkgreenStandard;
iconImages[VesselColour.DARKRED] = darkredStandard;
iconImages[VesselColour.GRAY] = grayStandard;
iconImages[VesselColour.LIGHTBLUE] = lightblueStandard;
iconImages[VesselColour.LIGHTGREEN] = lightgreenStandard;
iconImages[VesselColour.LIGHTRED] = lightredStandard;
iconImages[VesselColour.MAGENTA] = magentaStandard;
iconImages[VesselColour.ORANGE] = orangeStandard;
iconImages[VesselColour.PURPLE] = purpleStandard;
iconImages[VesselColour.SALMON] = salmonStandard;
iconImages[VesselColour.VIOLET] = violetStandard;
iconImages[VesselColour.WHITE] = whiteStandard;
iconImages[VesselColour.YELLOW] = yellowStandard;

export default iconImages;
